import React from "react";

const MONTHS = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
];

const ACTIVITY_OPTIONS = [
    { value: "all", label: "All items" },
    { value: "purchased", label: "Purchased this month" },
    { value: "sold", label: "Sold this month" },
    { value: "purchased_or_sold", label: "Purchased or sold" },
    { value: "no_activity", label: "No purchase / sale" },
    { value: "scanned", label: "Scanned this month" },
    { value: "over_short", label: "Over / Short mismatch" },
    { value: "over", label: "Over (On Hand > Book)" },
    { value: "short", label: "Short (On Hand < Book)" },
    { value: "missing_description", label: "Missing description" },
    { value: "not_in_price_book", label: "Not in price book" },
];

const InventoryLookupFilters = ({
    year,
    setYear,
    month,
    setMonth,
    show,
    setShow,
    activity,
    setActivity,
    scan_code,
    setScan_code,
    description,
    setDescription,
    department,
    setDepartment,
    departments,
    setPage,
}) => {
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 6 }, (_, i) => currentYear - i);

    return (
        <div className="space-y-3">
            <div className="flex flex-wrap gap-3 items-end">
                <div>
                    <label className="block text-[11px] uppercase tracking-wide text-slate-500 font-semibold mb-1">Month</label>
                    <select
                        className="border border-gray-300 rounded-lg px-3 py-2 text-[14px] outline-none"
                        value={month}
                        onChange={(e) => { setMonth(Number(e.target.value)); setPage(1); }}
                    >
                        {MONTHS.map((label, index) => (
                            <option key={label} value={index + 1}>{label}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label className="block text-[11px] uppercase tracking-wide text-slate-500 font-semibold mb-1">Year</label>
                    <select
                        className="border border-gray-300 rounded-lg px-3 py-2 text-[14px] outline-none"
                        value={year}
                        onChange={(e) => { setYear(Number(e.target.value)); setPage(1); }}
                    >
                        {years.map((y) => (
                            <option key={y} value={y}>{y}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label className="block text-[11px] uppercase tracking-wide text-slate-500 font-semibold mb-1">Show (base set)</label>
                    <select
                        className="border border-gray-300 rounded-lg px-3 py-2 text-[14px] outline-none min-w-[200px] font-medium"
                        value={show}
                        onChange={(e) => { setShow(e.target.value); setPage(1); }}
                    >
                        <option value="scanned">Scanned items only</option>
                        <option value="all">All price book items</option>
                    </select>
                </div>

                <div>
                    <label className="block text-[11px] uppercase tracking-wide text-indigo-600 font-semibold mb-1">
                        Activity (within show)
                    </label>
                    <select
                        className="border border-indigo-200 bg-indigo-50 rounded-lg px-3 py-2 text-[14px] outline-none min-w-[220px] font-medium text-indigo-900"
                        value={activity}
                        onChange={(e) => { setActivity(e.target.value); setPage(1); }}
                    >
                        {ACTIVITY_OPTIONS.map((opt) => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                    </select>
                </div>
            </div>

            <p className="text-[12px] text-slate-500">
                Each Retail = weighted sale retail this month if entered; otherwise Store Price Book
                each_retail. Purchases never affect Each Retail. Check the Each Retail column (not Total
                Retail — Total Retail is Each Retail × On Hand, so it is $0 when On Hand is 0).
            </p>

            <div className="flex flex-wrap gap-3">
                <div className="flex items-center border border-gray-300 rounded-lg px-3 py-2 min-w-[180px]">
                    <i className="fa-solid fa-magnifying-glass text-gray-300 mr-2" />
                    <input
                        type="text"
                        className="w-full text-[14px] outline-none"
                        placeholder="UPC..."
                        value={scan_code}
                        onChange={(e) => { setScan_code(e.target.value); setPage(1); }}
                    />
                </div>

                <div className="flex items-center border border-gray-300 rounded-lg px-3 py-2 min-w-[200px]">
                    <i className="fa-solid fa-magnifying-glass text-gray-300 mr-2" />
                    <input
                        type="text"
                        className="w-full text-[14px] outline-none"
                        placeholder="Description..."
                        value={description}
                        onChange={(e) => { setDescription(e.target.value); setPage(1); }}
                    />
                </div>

                <select
                    className="border border-gray-300 rounded-lg px-3 py-2 text-[14px] outline-none min-w-[180px]"
                    value={department}
                    onChange={(e) => { setDepartment(e.target.value); setPage(1); }}
                >
                    <option value="">All Departments</option>
                    {departments.map((dept) => (
                        <option key={dept} value={dept}>{dept}</option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default InventoryLookupFilters;
